import { ThemeId } from '@stadionhq-v3/core';
import { GatewayCarouselProps } from '@stadionhq-v3/base-ui';
import { GatewayCarouselBlock, Link } from '@graphql/__generated__/graphql';
import { Locale } from '@core/constants/locales.constants';
import { isRtlLocale } from '@utils/locales.utils/locales.utils';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { Translations } from '@lib/dictionary-keys/__generated__';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import GatewayCard from '@components/v3/molecules/gateway-card';
import { ChevronRight, ChevronLeft } from '@components/icons';
import { linkTransform } from '../atoms';

const gatewayCarouselBlockTransform = (
  {
    carouselTitle,
    subTitle,
    gatewayCards,
    link,
    theme,
  }: CleanContentful<GatewayCarouselBlock>,
  locale: Locale,
  dictionary: {
    previousAction: Translations['common']['action']['previous'];
    nextAction: Translations['common']['action']['next'];
  }
): GatewayCarouselProps => ({
  title: carouselTitle || '',
  subTitle: subTitle || '',
  cards: gatewayCards
    ?.filter(Boolean)
    .map((card) => (
      <GatewayCard
        key={card?.id as string}
        title={card?.subTitle || ''}
        summary={card?.summary || ''}
        subTitle={card?.gatewayCardTitle || ''}
        image={card?.image && <ContentfulImage {...card.image} />}
        link={card?.link?.url ? linkTransform(card?.link, locale) : undefined}
      />
    )),
  link: link?.url
    ? linkTransform(link as CleanContentful<Link>, locale)
    : undefined,
  theme: {
    themeId: theme?.themeId as ThemeId,
    title: theme?.title as string,
  },
  previousButton: {
    text: dictionary.previousAction,
    iconBefore: isRtlLocale(locale) ? <ChevronRight /> : <ChevronLeft />,
  },
  nextButton: {
    text: dictionary.nextAction,
    iconBefore: isRtlLocale(locale) ? <ChevronLeft /> : <ChevronRight />,
  },
  options: {
    direction: isRtlLocale(locale) ? 'rtl' : 'ltr',
  },
});

export default gatewayCarouselBlockTransform;
